import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Motion, spring} from 'react-motion'

import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion'

import CustomPropTypes from '../customPropTypes'

const ZeroHeight = ({children, className, isOpen}) => {
  const [childHeight, setChildHeight] = useState(0)
  const prefersReducedMotion = usePrefersReducedMotion()
  const childRef = useRef(null)
  const parentHeight = isOpen ? childHeight : 0

  useEffect(() => {
    setChildHeight(childRef.current.clientHeight)
  }, [childRef])

  return (
    <Motion style={{height: prefersReducedMotion ? parentHeight : spring(parentHeight)}}>
      {(interpolatingStyle) => (
        <div
          className={className}
          style={{height: `${interpolatingStyle.height}px`, overflow: 'hidden'}}
        >
          <div ref={childRef} style={{overflow: 'hidden'}}>
            {children}
          </div>
        </div>
      )}
    </Motion>
  )
}

ZeroHeight.propTypes = {
  className: PropTypes.string,
  children: CustomPropTypes.children,
  isOpen: PropTypes.bool,
}

export default ZeroHeight
